<template>
  <div>
    <el-menu
      :default-active="$route.fullPath"
      class="el-main-menu"
      router
      @select="hideDrawerOnSelectItem"
    >
      <el-menu-item
        :index="getRouteString({ name: 'User' })"
        :route="{ name: 'User' }"
      >
        <i class="el-icon-user" />
        <span>{{ $t('menu.profile') }}</span>
      </el-menu-item>
      <el-menu-item
        v-if="isBusiness || isAdmin"
        :index="getRouteString({ name: 'Organizations' })"
        :route="{ name: 'Organizations' }"
      >
        <i class="el-icon-suitcase-1" />
        <span>{{ $t('menu.organizations') }}</span>
      </el-menu-item>
      <el-submenu index="report">
        <template slot="title">
          <i class="el-icon-document" />
          <span>{{ $t('menu.reports.title') }}</span>
        </template>
        <el-menu-item
          v-if="isBusiness || isAdmin"
          :index="getRouteString({ name: 'HtmlReport', params: { type: 'fn8' } })"
          :route="{ name: 'HtmlReport', params: { type: 'fn8' } }"
        >
          <i class="el-icon-document" />
          <span>{{ $t('menu.reports.my-organizations') }}</span>
        </el-menu-item>
        <el-menu-item
          v-if="isBusiness || isAdmin"
          :index="getRouteString({ name: 'HtmlReport', params: { type: 'fn9' } })"
          :route="{ name: 'HtmlReport', params: { type: 'fn9' } }"
        >
          <i class="el-icon-document" />
          <span>{{ $t('menu.reports.employees') }}</span>
        </el-menu-item>
        <el-menu-item
          v-if="isBusiness || isAdmin"
          :index="getRouteString({ name: 'HtmlReport', params: { type: 'fn10' } })"
          :route="{ name: 'HtmlReport', params: { type: 'fn10' } }"
        >
          <i class="el-icon-document" />
          <span>{{ $t('menu.reports.payments') }}</span>
        </el-menu-item>
        <el-menu-item
          v-if="!isBusiness && !isAdmin"
          :index="getRouteString({ name: 'HtmlReport', params: { type: 'fn11' } })"
          :route="{ name: 'HtmlReport', params: { type: 'fn11' } }"
        >
          <i class="el-icon-document" />
          <span>{{ $t('menu.reports.payments') }}</span>
        </el-menu-item>
        <el-menu-item
          v-if="isAdmin"
          :index="getRouteString({ name: 'HtmlReport', params: { type: 'fn19' } })"
          :route="{ name: 'HtmlReport', params: { type: 'fn19' } }"
        >
          <i class="el-icon-document" />
          <span>{{ $t('menu.reports.recent-employees') }}</span>
        </el-menu-item>
        <el-menu-item
          v-if="isAdmin"
          :index="getRouteString({ name: 'HtmlReport', params: { type: 'fn20' } })"
          :route="{ name: 'HtmlReport', params: { type: 'fn20' } }"
        >
          <i class="el-icon-document" />
          <span>{{ $t('menu.reports.outline-payments') }}</span>
        </el-menu-item>
        <!-- <el-menu-item
          v-if="!isAdmin && (isEmployee && (isBusiness || isTeamResp)) || !isAdmin && (isBusiness || isTeamResp)"
          :index="getRouteString({ name: 'HtmlReport', params: { type: 'fn23' } })"
          :route="{ name: 'HtmlReport', params: { type: 'fn23' } }"
        >
          <i class="el-icon-document" />
          <span>{{ $t('menu.reports.teams-payments') }}</span>
        </el-menu-item> -->
        <el-menu-item
          v-if="!isAdmin && (isEmployee && (isBusiness || isTeamResp)) || !isAdmin && (isBusiness || isTeamResp)"
          :index="getRouteString({ name: 'HtmlReport', params: { type: 'fn24' } })"
          :route="{ name: 'HtmlReport', params: { type: 'fn24' } }"
        >
          <i class="el-icon-document" />
          <span>{{ $t('menu.reports.team-pooling-results') }}</span>
        </el-menu-item>
      </el-submenu>
      <!-- <el-menu-item
        v-if="isTeamResp || (isEmployee && !isTeamResp)"
        :index="getRouteString({ name: 'SelectTeam' })"
        :route="{ name: 'SelectTeam' }"
      >
        <i class="el-icon-money" />
        <span v-if="isTeamResp">{{ $t('re-conciliation.title') }}</span>
        <span v-if="isEmployee && !isTeamResp">{{ $t('re-conciliation.transfer-to-iban') }}</span>
      </el-menu-item> -->
      <el-menu-item
        v-if="isTeamResp"
        :index="getRouteString({ name: 'SelectTeam' })"
        :route="{ name: 'SelectTeam' }"
      >
        <i class="el-icon-money" />
        <span>{{ $t('re-conciliation.title') }}</span>
      </el-menu-item>
      <el-menu-item
        v-if="isEmployee && !isTeamResp"
        @click="showEmployeeReconciliationDialog"
      >
        <i class="el-icon-money" />
        <span>{{ $t('re-conciliation.transfer-to-iban') }}</span>
      </el-menu-item>
      <el-menu-item
        :index="getRouteString({name: 'UploadPassport'})"
        :route="{name: 'UploadPassport'}"
      >
        <i class="el-icon-document-add" />
        {{ $t('menu.passport') }}
      </el-menu-item>
      <el-menu-item
        v-if="isBusiness || isAdmin"
        :index="getRouteString({ name: 'SignUp' })"
        :route="{ name: 'SignUp' }"
      >
        <i class="el-icon-circle-plus-outline" />
        <span>{{ $t('menu.sign-up') }}</span>
      </el-menu-item>
      <el-submenu
        v-if="isAdmin"
        index="on-boarding"
      >
        <template slot="title">
          <i class="el-icon-edit-outline" />
          <span>{{ $t('on-boarding.title') }}</span>
        </template>
        <el-menu-item
          :index="getRouteString({ name: 'OnBoardingUsers' })"
          :route="{ name: 'OnBoardingUsers' }"
        >
          <i class="el-icon-s-check" />
          <span>{{ $tc('on-boarding.user', 2) }}</span>
        </el-menu-item>
      </el-submenu>
      <el-menu-item
        v-if="isAdmin"
        @click="showDeleteUserDialog"
      >
        <i class="el-icon-delete-solid" />
        <span>{{ $t('menu.delete-user') }}</span>
      </el-menu-item>
    </el-menu>
    <el-divider
      class="burger-menu-divider"
      direction="horizontal"
    />
    <LanguageSwitcher
      class="mb-10"
    />
    <el-menu
      default-active="2"
      class="el-additional-menu"
    >
      <el-menu-item
        index="signOut"
        @click="showSignOutDialog"
      >
        <span>{{ $t('menu.sign-out') }}</span>
      </el-menu-item>
    </el-menu>
  </div>
</template>

<script>
import LanguageSwitcher from './LanguageSwitcher';

export default {
  name: 'Navigation',
  components: {
    LanguageSwitcher
  },
  props: {
    isAdmin: {
      type: Boolean,
      default: false
    },
    isBusiness: {
      type: Boolean,
      default: false
    },
    isTeamResp: {
      type: Boolean,
      default: false
    },
    isEmployee: {
      type: Boolean,
      default: false
    },
    hasIban: {
      type: Boolean,
      default: false
    },
    signOutDialog: {
      type: Boolean,
      default: false
    },
    deleteUserDialog: {
      type: Boolean,
      default: false
    },
    employeeReconciliationDialog: {
      type: Boolean,
      default: false
    },
    drawer: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    getRouteString (routeObject = {}) {
      const location = this.$router.resolve(routeObject);
      return location.route.fullPath || '';
    },
    reConciliation () {
      this.$adminApi.post('/api/v1/qrcodes').then((response) => {
        this.$store.dispatch('setReConciliationResponse', response.data);
        this.$router.push({ name: 'ReConciliationThankYou' });
      });
    },
    showSignOutDialog () {
      this.$emit('update:signOutDialog', true);
    },
    showDeleteUserDialog () {
      this.$emit('update:deleteUserDialog', true);
    },
    showEmployeeReconciliationDialog () {
      this.$emit('update:employeeReconciliationDialog', true);
    },
    hideDrawerOnSelectItem () {
      this.$emit('update:drawer', false);
    }
  }
};
</script>

<style scoped>

</style>
